import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // KaziPeople design-system field: radius 10, 1.5px border, focus orange.
          "flex h-10 w-full rounded-[10px] border-[1.5px] border-border bg-card px-3.5 py-2.5 text-[13px] text-foreground file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground transition-colors focus-visible:outline-none focus-visible:border-orange-500 disabled:cursor-not-allowed disabled:opacity-65 disabled:bg-muted",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

Input.displayName = "Input"

export { Input }
